// Restore the URL before imported routers and auth providers initialize.
import '@/lib/navigation/restoreCrossAppNavigation';
import App from '@/App';
import { initSentry } from '@/lib/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { preventEdgeTranslatorDomCrash } from './lib/preventEdgeTranslatorDomCrash';

initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

preventEdgeTranslatorDomCrash();
